import { gql, useMutation, useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { addLocalCartItem, deleteLocalCartItem } from '../store/actions';

function useHandleSwatchCart() {
  const dispatch = useDispatch();
  const localCart = useSelector(state => state.LocalCart.localCart);
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);

  const { loading: loadingCart, error: errorCart, data: dataCart } = useQuery(
    GET_ALL_CART_PRODUCTS,
    {
      skip: !isAuthenticated,
      variables: {
        type: 'swatch'
      }
    }
  );

  const [addToCart, { loading: loadingAdd, error, data }] = useMutation(
    CREATE_CART_PRODUCT,
    {
      refetchQueries: [
        { query: GET_TOTAL_CART_PRODUCTS },
        {
          query: GET_ALL_CART_PRODUCTS,
          variables: {
            type: 'swatch'
          }
        }
      ]
    }
  );

  const [deleteCartProduct, { loading: loadingDelete }] = useMutation(
    DELETE_CART_PRODUCT,
    {
      refetchQueries: [
        { query: GET_TOTAL_CART_PRODUCTS },
        {
          query: GET_ALL_CART_PRODUCTS,
          variables: {
            type: 'swatch'
          }
        }
      ]
    }
  );

  const checkIfIsInCart = swatchId => {
    if (isAuthenticated) {
      if (dataCart) {
        return dataCart.getAllCartProducts.some(
          product => parseInt(product.product_id) === parseInt(swatchId)
        );
      }
    } else {
      return localCart.some(
        cartItem => parseInt(cartItem.product_id) === parseInt(swatchId)
      );
    }
  };

  const handleCart = (swatch, source = '') => {
    if (isAuthenticated) {
      if (checkIfIsInCart(swatch.id)) {
        deleteCartProduct({
          variables: { product_id: swatch.id }
        });
      } else {
        addToCart({
          variables: {
            quantity: 1,
            product_id: swatch.id,
            type: 'increase',
            source
          }
        });
      }
    } else {
      if (checkIfIsInCart(swatch.id)) {
        dispatch(deleteLocalCartItem(swatch.id));
      } else {
        dispatch(addLocalCartItem(swatch));
      }
    }
  };

  const loading = loadingAdd || loadingDelete;

  return [handleCart, { loadingAdd, loading, checkIfIsInCart }];
}

export default useHandleSwatchCart;

const GET_TOTAL_CART_PRODUCTS = gql`
  query getTotalCartProducts {
    getTotalCartProducts {
      total
    }
  }
`;

const CREATE_CART_PRODUCT = gql`
  mutation createCartProduct(
    $product_id: ID!
    $quantity: Int!
    $type: String!
    $source: Int
  ) {
    createCartProduct(
      product_id: $product_id
      quantity: $quantity
      type: $type
      source: $source
    ) {
      id
      quantity
    }
  }
`;

const DELETE_CART_PRODUCT = gql`
  mutation deleteCartProduct($product_id: ID!) {
    deleteCartProduct(product_id: $product_id) {
      id
      product_id
    }
  }
`;

const GET_ALL_CART_PRODUCTS = gql`
  query getAllCartProducts($type: String!) {
    getAllCartProducts(type: $type) {
      id
      product_id
      quantity
      product {
        id
        slug
        sku
        price
        name
        is_purchasable
        fabric {
          id
          is_available_on_pdp
          name
          image
          collaborator {
            id
            name
          }
        }
      }
    }
  }
`;
